//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

  //name: 'AcademyIndex',


  data() {
    return {
      courses: {},
      showVideo: true,
      videoOptions: {
        /*height: 250,
        width: 525,*/
        fluid: true,
        responsive: true,
        controls: true,
        autoplay: false,
        preload: 'none',
        poster: require('~/assets/images/academy/video-image-poster.jpg'),
        html5: {
          vhs: {
            withCredentials: true,
            overrideNative: true,
          },
          nativeAudioTracks: false,
          nativeVideoTracks: false
        },
        sources: [
          {
            src: 'https://cdn.dev.evintra.com/public/uv100/uv100.m3u8',
            type: 'application/x-mpegURL',
            withCredentials: true,
          }
        ]
      },
    }
  },

  async asyncData({ $axios, $logger, $ziggy }) {

    let courses = {}

    try {
      const response = await $axios.$get($ziggy.route('api.academy.courses.overview'))
      courses = response.data
    } catch (e) {
      $logger.captureExceptionAxios(e)
    }

    return { courses }

  },

  methods: {

    playVideo() {

      const src = {
        src: 'https://cdn.dev.evintra.com/public/uv100/uv100.m3u8',
        type: 'application/x-mpegURL',
        withCredentials: true,
      }

      this.videoOptions.sources.push(src)

      this.showVideo = true

    },

  },

}

